export enum CoverageGroupLayoutEnum {
    Vertical = 'vertical',
    Card = 'card',
    Bordered = 'bordered',
    Default = 'default',
}
